export default __webpack_public_path__ + "9ed014b.png";